const PHONE_NUMBER = "917490019959";

export const getWhatsAppUrl = (message: string): string => {
  return `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(message)}`;
};

// Pre-defined messages for different contexts
export const whatsappMessages = {
  header: "Hello Feel Free Holidays, I'm interested in planning a trip. Please share your best travel packages.",
  home: "Hello Feel Free Holidays, I'm interested in planning a trip. Please share your best travel packages.",
  contact: "Hello Feel Free Holidays, I would like assistance regarding your travel services.",
  services: "Hello Feel Free Holidays, I'm interested in your travel services. Please share details about your offerings.",
  destinations: "Hello Feel Free Holidays, I would like to explore your destination packages. Please share more details.",
  faq: "Hello Feel Free Holidays, I have some questions about your travel services. Can you help?",
  blog: "Hello Feel Free Holidays, I came across your travel blog and would like assistance planning my trip.",
  visa: "Hello Feel Free Holidays, I need assistance with visa services. Please share the requirements.",
  notFound: "Hello Feel Free Holidays, I need some help navigating your website. Can you assist?",
  
  // Dynamic messages
  destination: (name: string) => 
    `Hello Feel Free Holidays, I would like to know more about your ${name} holiday packages. Please share details.`,
  
  package: (title: string, destination?: string) => 
    `Hello Feel Free Holidays, I'm interested in the "${title}"${destination ? ` to ${destination}` : ''} package. Please share pricing and availability.`,
  
  blogPost: (title: string) => 
    `Hello Feel Free Holidays, I read your blog "${title}" and would like assistance planning a similar trip.`,
};
